import { Component, EventEmitter, Input, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { NgTemplateOutlet, NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';

/** animation for expanding and collapsing an element's height */
export const expandCollapseAnimation = trigger('expandCollapse', [
	state(
		'open',
		style({
			height: '*',
		})
	),
	state(
		'close',
		style({
			height: '0px',
			overflow: 'hidden',
		})
	),
	transition('open <=> close', animate(200)),
]);

@Component({
    selector: 'cr-expansion-panel',
    templateUrl: './expansion-panel.component.html',
    styleUrls: ['./expansion-panel.component.scss'],
    animations: [expandCollapseAnimation],
    imports: [FlexModule, MatIconButton, MatTooltip, NgTemplateOutlet, MatIcon, NgIf, MatDivider]
})
export class ExpansionPanelComponent {
	@Input() expanded = false;
	@Input() disabled = false;
	@Output() expandChange = new EventEmitter();
	protected animationState = 'close';

	constructor(private announcer: LiveAnnouncer) {}

	/**
	 * Flips the expansion panel `expanded` state.
	 *
	 * or close the panel accordingly
	 * @param force if given, will force the `expanded` state accordingly
	 */
	toggle(force?: boolean) {
		this.expanded = force === undefined ? !this.expanded : force;
		this.animationState = this.expanded ? 'open' : 'close';
		if (this.expandChange) {
			this.expandChange.emit(this.expanded);
		}

		this.announcer.announce(this.expanded ? 'Scan properties expended' : 'Scan properties collapsed', 'assertive');
	}
}

@Component({
    selector: 'cr-expansion-panel-title',
    template: '<ng-content></ng-content>',
    styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelTitleComponent {}

@Component({
    selector: 'cr-expansion-panel-menu',
    template: `
		<ng-content accept="cr-expansion-panel-menu-item"></ng-content>
	`,
    styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelMenuComponent {}

@Component({
    selector: 'cr-expansion-panel-menu-item',
    template: `
		<mat-divider vertical="true"></mat-divider>
		<ng-content></ng-content>
	`,
    styleUrls: ['./expansion-panel.component.scss'],
    imports: [MatDivider]
})
export class ExpansionPanelMenuItemComponent {}

@Component({
    selector: 'cr-expansion-panel-body',
    template: '<ng-content></ng-content>',
    styleUrls: ['./expansion-panel.component.scss']
})
export class ExpansionPanelBodyComponent {}
